export const mobile = window.screen.width < 480
export const GAME_HEIGHT = (mobile) ? 812 : 797;
export const GAME_WIDTH = (mobile) ? 375 : 1440;
export const scaleRatio = window.devicePixelRatio / 3;
export const LEFT_UI_WIDTH = 50;